import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveBitrixContainer } from "../../components/ActiveBitrixContainer/ActiveBitrixContainer";

const ActiveBitrixScreen = () => {
  return (
    <ScreenLayout>
      <ActiveBitrixContainer />
    </ScreenLayout>
  );
};

export default ActiveBitrixScreen;
